import { communicationsApi } from '@app/services'
import { isBuyerView } from '@app/utils'
import { isImpersonatedB2BSession } from '@app/utils/token/isImpersonatedB2BSession'

import { JoinChatResponse } from './types'

export const joinChat = async (
  identity: string,
  token: string,
  convId: number
) => {
  if (isBuyerView() || isImpersonatedB2BSession()) {
    return { acsChatThreadId: '' }
  }

  const { data } = await communicationsApi.post<JoinChatResponse>(
    `/chat/${convId}/join`,
    null,
    {
      headers: {
        'X-ACS-ParticipantId': identity,
        'X-ACS-Token': token,
      },
    }
  )

  return data
}
